import { useEffect, useState } from 'react';

import { localStorageFacade } from '@townsquare/facade';

import { haveISeenItClient } from '../../clients/have-i-seen-it';

const onboardingKey = 'NO_WORKSPACE_BENEFITS_DIALOG';

export const useSaveBenefitsOnboarding = () => {
  const [shouldOpenByDefault, setShouldOpenByDefault] = useState(false);
  const [hasLoaded, setHasLoaded] = useState(false);

  useEffect(() => {
    void haveISeenItClient
      .hasSeenFlag(onboardingKey)
      .then(hasSeenFlag => {
        if (hasSeenFlag) {
          return;
        }
        setShouldOpenByDefault(true);
        const localStorageValue = localStorageFacade.getItem(onboardingKey);
        if (!localStorageValue) {
          localStorageFacade.setItem(onboardingKey, '1');
          return;
        } else {
          const viewCount = parseInt(localStorageValue);
          if (viewCount >= 2) {
            void haveISeenItClient.setHasSeenFlag(onboardingKey);
          } else {
            localStorageFacade.setItem(onboardingKey, (viewCount + 1).toString());
          }
        }
      })
      .finally(() => {
        setHasLoaded(true);
      });
  }, [setShouldOpenByDefault]);

  return { shouldOpenByDefault, hasLoaded };
};
